import * as React from "react";

const Info: React.FC = () => {
    return (
        <svg
            focusable="false"
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="17"
            viewBox="0 0 16 17"
            fill="none"
        >
            <g clip-path="url(#clip0_6008_215561)">
                <path d="M7.33203 5.16683H8.66536V6.50016H7.33203V5.16683ZM7.33203 7.8335H8.66536V11.8335H7.33203V7.8335ZM7.9987 1.8335C4.3187 1.8335 1.33203 4.82016 1.33203 8.50016C1.33203 12.1802 4.3187 15.1668 7.9987 15.1668C11.6787 15.1668 14.6654 12.1802 14.6654 8.50016C14.6654 4.82016 11.6787 1.8335 7.9987 1.8335ZM7.9987 13.8335C5.0587 13.8335 2.66536 11.4402 2.66536 8.50016C2.66536 5.56016 5.0587 3.16683 7.9987 3.16683C10.9387 3.16683 13.332 5.56016 13.332 8.50016C13.332 11.4402 10.9387 13.8335 7.9987 13.8335Z" fill="currentColor"/>
            </g>
            <defs>
                <clipPath id="clip0_6008_215561">
                    <rect width="16" height="16" fill="white" transform="translate(0 0.5)"/>
                </clipPath>
            </defs>
        </svg>
    );
};

export default React.memo(Info);
